export const FORBIDDEN_PROPERTY_KEYS_LOWER: ReadonlySet<string> = new Set([
  'access_token',
  'refresh_token',
  'hashmfa',
  'senha',
  'password',
  'senhacoacao',
  'palavrachave'
]);

export const REDACTED_PROPERTY_KEYS_LOWER: ReadonlySet<string> = new Set([
  'cpf',
  'cnpj',
  'rg',
  'passaporte',
  'documento',
  'placa',
  'telefone',

  'foto',
  'qrcode',
  'chavevirtual',
  'tokenmfa'
]);

export const MAX_DEPTH = 5;

export const REDACTED_VALUE = '[REDACTED]';

export const DEPTH_LIMIT_VALUE = '[DEPTH_LIMIT]';

export const CIRCULAR_VALUE = '[CIRCULAR]';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  return value.constructor === Object;
}

export function redactSensitiveProperties<T>(
  value: T,
  depth: number = 0,
  seen: WeakSet<object> = new WeakSet()
): T {

  if (value === null || value === undefined || typeof value !== 'object') {
    return value;
  }
  if (depth > MAX_DEPTH) {
    return DEPTH_LIMIT_VALUE as unknown as T;
  }

  if (seen.has(value)) {
    return CIRCULAR_VALUE as unknown as T;
  }

  if (Array.isArray(value)) {
    seen.add(value);
    return value.map((item) =>
      redactSensitiveProperties(item, depth + 1, seen)
    ) as unknown as T;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  seen.add(value);
  const out: Record<string, unknown> = {};
  for (const [key, child] of Object.entries(value as Record<string, unknown>)) {
    const keyLower = key.toLowerCase();

    if (FORBIDDEN_PROPERTY_KEYS_LOWER.has(keyLower)) {
      continue;
    }

    if (REDACTED_PROPERTY_KEYS_LOWER.has(keyLower)) {
      out[key] = REDACTED_VALUE;
      continue;
    }

    out[key] = redactSensitiveProperties(child, depth + 1, seen);
  }
  return out as unknown as T;
}
